export type SubscriptionStatus = 'published' | 'draft' | 'scheduled'

export const SubscriptionStatuses: SubscriptionStatus[] = ['draft', 'scheduled', 'published']


export type SubscriptionConfigStep = 'plans' | 'benefits' | 'extras' | 'discounts' | 'fees'

export const RequiredSubscriptionConfigSteps: SubscriptionConfigStep[] = ['plans', 'benefits']
export const OptionalSubscriptionConfigSteps: SubscriptionConfigStep[] = ['extras', 'discounts', 'fees']